import AxiosInstance from "./AxiosInstance";

export const getAllHotels = async () => {
  try {
    const { data } = await AxiosInstance.get("/hotels");
    return data?.hotels;
  } catch (error) {
    console.log(error);
  }
};
